//
const PurchaseOrderDetailHeaders = [
    {
        text: 'código de proveedor',
        value: 'provider_product_code',
        input: {
            reverse: true,
            min: 1,
            type: 'text-field',
        },
        width: '10%',
    },
    {
        text: 'código interno',
        value: 'internal_code',
        width: '10%',
    },
    {
        text: 'nombre',
        value: 'name',
    },
    {
        text: 'recepcionado',
        value: 'received',
        align: 'right',
        width: '10%',
    },
    {
        text: 'precio neto',
        value: 'net_price',
        format: 'currency',
        input: {
            reverse: true,
            type: 'currency-field',
        },
        align: 'right',
        width: '10%',
    },
    {
        text: 'cantidad',
        value: 'quantity',
        format: 'number',
        input: {
            reverse: true,
            type: 'float-field',
        },
        align: 'right',
        width: '10%',
    },
]

//
const PurchaseOrderOrdererHeaders = [
    {
        text: '#',
        value: 'id',
        width: '10%',
        component: {
            custom: 'id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'orderer-update',
                    params: {
                        id: value,
                    },
                }),
                tooltip: 'Detalle solicitud abastecimiento',
            },
        },
    },
    {
        text: 'rut',
        value: ({ pch_provider }) => pch_provider.rut,
        format: 'rut',
        width: '10%',
    },
    {
        text: 'proveedor',
        value: ({ pch_provider }) => pch_provider.alias_name,
        component: {
            custom: 'pch_provider_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'provider-update',
                    params: {
                        id: value,
                    },
                }),
                tooltip: 'Detalle proveedor',
            },
        },
    },
    {
        text: 'sucursal',
        value: ({ pch_provider_branch_offices }) =>
            pch_provider_branch_offices.address,
    },
    {
        text: 'procesada',
        value: 'was_processed',
        align: 'center',
        format: 'boolean',
        width: '10%',
    },
    {
        text: 'fecha de creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
]

//
export { PurchaseOrderDetailHeaders, PurchaseOrderOrdererHeaders }
